import { EBasicField } from 'src/app/project/shared/enums/basic-fields-enums';
import { ERowType } from 'src/app/project/shared/enums/row-type.enum';
import { GET_GROUPING } from '../../../columns/grouping.store';
import { TGroupedPoints } from '../../../grouping/group-model';
import { GET_COLLAPSED_GROUPS } from '../../../table.ui.store';
import { TTableItem } from '../../table.model';
import { EQuickSortTranslatedKey } from 'src/app/project/modules/filters/filters-api/sort/quick-sort.consts';

export function getGroupByValue(hiddenValue: string | undefined): string {
  if (hiddenValue === undefined || hiddenValue === null || hiddenValue === 'UNSPECIFIED') {
    return '';
  }

  return hiddenValue;
}

export function getGroupByFieldName(groupingField: string): string {
  switch (groupingField) {
    case 'id':
      return EQuickSortTranslatedKey.ID;
    case EBasicField.SITE:
      return EQuickSortTranslatedKey.SITE;
    case EBasicField.ACCOUNT:
      return EQuickSortTranslatedKey.ACCOUNT;
    case 'header.createdEpochMillis':
      return EQuickSortTranslatedKey.CREATED;
    case 'header.updatedEpochMillis':
      return EQuickSortTranslatedKey.UPDATED;
    case 'header.createdby.id':
      return EQuickSortTranslatedKey.CREATED_BY;
    default: {
      const column = GET_GROUPING().find(
        (col) => col.customFieldIds?.includes(groupingField) || col.name === groupingField,
      );
      if (column?.customFieldIds?.length) {
        return column.customFieldIds[0];
      }
      return groupingField.toLowerCase();
    }
  }
}

export function generateGroupedPointItems(groupedTable: TGroupedPoints[]): TTableItem[] {
  const collapsedGroups = GET_COLLAPSED_GROUPS();

  let items: TTableItem[] = [];

  items = groupedTable.flatMap((groupedPoints, groupIndex) => {
    const points: TTableItem[] = [];
    const collapsed = collapsedGroups.has(groupedPoints.id);

    if (groupIndex === 0) {
      points.push({
        type: ERowType.EMPTY,
      });
    }

    points.push({
      type: ERowType.HEADER,
      context: groupedPoints.value,
      id: groupedPoints.id,
      category: groupedPoints.category,
      hiddenValue: groupedPoints.hiddenValue,
      parentOption: groupedPoints.value,
      groupBy: {
        [getGroupByFieldName(groupedPoints.category)]: getGroupByValue(groupedPoints.hiddenValue),
      },
    });

    if (!collapsed) {
      generateFirstGroupPoints(groupedPoints, points);
    }

    points.push({
      type: ERowType.EMPTY,
    });

    return points;
  });

  return items;
}

function generateFirstGroupPoints(group: TGroupedPoints, points: TTableItem[]): void {
  if (group.group) {
    const parentGroupBy: Record<string, string> = {
      [getGroupByFieldName(group.category)]: getGroupByValue(group.hiddenValue),
    };
    generateSecondGroupPoints(group, points, parentGroupBy);
  } else {
    points.push(
      ...group.points.map((point) => ({
        type: ERowType.POINT,
        index: point,
        parentOption: group.parentOption,
        hiddenValue: group.hiddenValue,
        category: group.category,
      })),
    );
  }
}

function generateSecondGroupPoints(
  group: TGroupedPoints,
  points: TTableItem[],
  parentGroupBy: Record<string, string>,
): void {
  const collapsedGroups = GET_COLLAPSED_GROUPS();

  group.group.forEach((subGroup) => {
    const collapsedsubGroup = collapsedGroups.has(subGroup.id);

    const currentGroupBy = {
      ...parentGroupBy,
      [getGroupByFieldName(subGroup.category)]: getGroupByValue(subGroup.hiddenValue),
    };

    points.push({
      type: ERowType.GROUP_2,
      context: subGroup.value,
      id: subGroup.id,
      category: subGroup.category,
      parentOption: subGroup.parentOption,
      hiddenValue: subGroup.hiddenValue,
      groupBy: currentGroupBy,
    });

    if (!collapsedsubGroup) {
      if (subGroup.group) {
        generateThirdGroupPoints(subGroup, points, currentGroupBy);
      } else {
        points.push(
          ...subGroup.points.map((point) => ({
            type: ERowType.POINT,
            index: point,
            hiddenValue: subGroup.hiddenValue,
            category: subGroup.category,
          })),
        );
      }
    }

    points.push({
      type: ERowType.EMPTY_ROW_GROUP_1,
    });
  });
}

function generateThirdGroupPoints(
  subGroup: TGroupedPoints,
  points: TTableItem[],
  parentGroupBy: Record<string, string>,
): void {
  const collapsedGroups = GET_COLLAPSED_GROUPS();

  subGroup.group.forEach((subSubGroup) => {
    const collapsedSubsubGroup = collapsedGroups.has(subSubGroup.id);

    const currentGroupBy = {
      ...parentGroupBy,
      [getGroupByFieldName(subSubGroup.category)]: getGroupByValue(subSubGroup.hiddenValue),
    };

    points.push({
      type: ERowType.GROUP_3,
      context: subSubGroup.value,
      id: subSubGroup.id,
      category: subSubGroup.category,
      hiddenValue: subSubGroup.hiddenValue,
      groupBy: currentGroupBy,
    });

    if (!collapsedSubsubGroup) {
      points.push(
        ...subSubGroup.points.map((point) => ({
          type: ERowType.POINT,
          index: point,
          hiddenValue: subSubGroup.hiddenValue,
          category: subSubGroup.category,
        })),
      );
    }

    points.push({
      type: ERowType.EMPTY_ROW_GROUP_2,
    });
  });
}
